export enum LicenseTypeEnum {
  Student = 'STUDENT',
  Individual = 'INDIVIDUAL',
  Team = 'TEAM',
  Enterprise = 'ENTERPRISE',
  Questionnaire = 'QUESTIONNAIRE',
}